import { useState } from 'react';
import { aggregateScore, clearProgress } from '../lib/progress.js';

const SCORE_ROWS = [
  ['guided-practice', '📘', 'Guided Practice', 'score-guided'],
  ['sentence-building', '✍️', 'Sentence Building', 'score-building'],
  ['listen-spell', '🎧', 'Listen & Spell', 'score-spell'],
  ['listen-for-details', '🔎', 'Listen for Details', 'score-details'],
];

export default function AppHeader({ app, progress, onHome, onProgressReset }) {
  const [expanded, setExpanded] = useState(false);
  const total = aggregateScore(progress);

  function reset() {
    if (!window.confirm('Reset all locally saved scores on this device?')) return;
    onProgressReset(clearProgress());
    setExpanded(false);
  }

  return (
    <header className="app-header">
      <button className="brand-button" type="button" onClick={onHome}>
        <span className="brand-mark">PEV</span>
        <span>
          <small>HKDSE LEARNING SERIES</small>
          <strong>{app?.shortTitle ?? 'Progressive English Vocabulary'}</strong>
        </span>
      </button>

      <div className="score-menu">
        <button
          className="score-menu-button"
          type="button"
          aria-expanded={expanded}
          aria-label={`Total score ${total.score}. Show score details`}
          onClick={() => setExpanded((value) => !value)}
        >
          <span className="score-trophy" aria-hidden="true">🏆</span>
          <span><strong>{total.score}</strong><small>TOTAL SCORE</small></span>
        </button>
        {expanded && (
          <div className="score-popover">
            <h2>Total score</h2>
            <div className="score-breakdown">
              {SCORE_ROWS.map(([mode, emoji, label, className]) => {
                const value = aggregateScore(progress, null, mode).score;
                return (
                  <div className={className} key={mode}>
                    <span>{emoji} {label}</span>
                    <strong>{value}</strong>
                  </div>
                );
              })}
            </div>
            <div className="score-popover-total"><span>🏆 Total score</span><strong>{total.score}</strong></div>
            <button className="reset-progress-button" type="button" onClick={reset}>Reset local progress</button>
          </div>
        )}
      </div>
    </header>
  );
}
